import { graphql, useStaticQuery } from "gatsby";
import React, { FunctionComponent, useContext, useEffect, useState } from "react";
import About from "../../components/about";
import Section from "../../components/section";
import Speakers from "../../components/speakers";
import Sponsors from "../../components/sponsor/sponsors";
import Context from "../../context/Context";
import { Speaker } from "../../interfaces/interfaces";
import CTA from "../cta";
import NewHero from "../hero/new";
import { StyledPrimaryHeader } from "../styled";

const Main = () => {
  const { allCardsJson } = useStaticQuery(graphql`
    query ArticlesQuery {
      allCardsJson {
        cards: nodes {
          alt
          img
          text
        }
      }
    }
  `);
  const cards = allCardsJson.cards;
  const data = useContext(Context);
  const speakers: Speaker[] = data.speakers;
  const { singlePage, sponsors, sponsorLevels, isSpeakerBioEnabled } = data;
  const levels = sponsorLevels ? sponsorLevels : ["diamond"];
  const [sponsorsWithLevels, setSponsorsWithLevels] = useState({});

  useEffect(() => {
    const sWithLevels = {};

    levels.map((sponsorLevel) => {
      const sponsorsAtLevel = sponsors.filter(sponsor => sponsor?.sponsorLevel?.toLowerCase() === sponsorLevel);
      sWithLevels[sponsorLevel] = sponsorsAtLevel;
    });

    setSponsorsWithLevels(sWithLevels);
  }, []);

  return (
    <>
      <NewHero />
      {singlePage && (
        <div style={{ marginBottom: "52px" }}>
          <Section id="About">
            <div className="about-section">
            <About />
          <CTA />
            </div>
          </Section>
          <Section id="Speakers">
            <Speakers speakers={speakers} />
          </Section>
          <Section id="Sponsors">
            <Sponsors sponsorsWithLevels={sponsorsWithLevels} />
          </Section>
          <div id='become-a-sponsor'>
      <StyledPrimaryHeader>Become a Sponsor</StyledPrimaryHeader>
      <p>
      For more information about becoming a sponsor,
        <br />
        contact us at{" "}
        <a
        className="become-a-sponsor-link"
          href="mailto:federalforumsponsorships@scoopnewsgroup.com?subject=FedScoop Federal Forum 2025 - Become a Sponsor"
          target="_blank"
          >
          federalforumsponsorships@scoopnewsgroup.com
        </a>
      </p>
      </div>
        </div>
      )}
    </>
  );
};

export default Main;


interface CardContainerProps {
  children: any;
}

interface CardProps {
  img: string;
  text: string;
  alt: string;
}
